/**
 * Create and display a single toast message
 */
const Toast = (() =>
{
	let container = null;
	const displayedToasts = [];

	const init = () =>
	{
		if (!container)
		{
			container = document.createElement('div');
			container.className = 'morning-sun toast-container';
			document.body.appendChild(container);
		}
	};

	const toastExists = (type, title, description) =>
	{
		return displayedToasts.some(t => 
			t.type === type && t.title === title && t.description === description
		);
	};

	const createToast = ({ type = 'info', title, description, duration = 3000 }) =>
	{
		init();

		// Check if we already have the exact message showing
		if (toastExists(type, title, description))
		{
			return null;
		}

		const toastData = { type, title, description };
		displayedToasts.push(toastData);

		const toast = document.createElement('div');
		toast.className = `toast ${type} show`;

		const header = document.createElement('div');
		header.className = 'toast-header';

		const titleEl = document.createElement('div');
		titleEl.className = 'toast-title';
		//titleEl.textContent = title;
		titleEl.innerHTML = title;

		const closeBtn = document.createElement('button');
		closeBtn.className = 'toast-close';
		closeBtn.innerHTML = '×';
		closeBtn.setAttribute('aria-label', 'Close');

		header.appendChild(titleEl);
		header.appendChild(closeBtn);
		toast.appendChild(header);
		

		if (description)
		{
			const descEl = document.createElement('div');
			descEl.className = 'toast-description';
			//descEl.textContent = description;
			descEl.innerHTML = description;
			toast.appendChild(descEl);
		}
		else
		{
			header.className = 'toast-header no-description';
		}


		
		const removeToast = () =>
		{
			toast.classList.add('removing');
			setTimeout(() =>
			{
				if (toast.parentNode)
				{
					container.removeChild(toast);
				}
				const index = displayedToasts.indexOf(toastData);
				if (index > -1)
				{
					displayedToasts.splice(index, 1);
				}
			}, 300);
		};

		closeBtn.addEventListener('click', removeToast);

		container.appendChild(toast);

		if (duration > 0)
		{
			setTimeout(removeToast, duration);
		}

		return toast;
	};

	return { createToast };
})();









//TODO: Why did I do this. Overkill.
// //NOTE: I thought about using a pub/sub for notifications, but it's not really needed.
// //		I've kept the original code that Claude created as an example. We may have
// //		a valid use case for EventBus in the future.
// const EventBus = (() =>
// {
// 	const subscribers = {};

// 	const subscribe = (event, callback) =>
// 	{
// 		if (!subscribers[event])
// 		{
// 			subscribers[event] = [];
// 		}
// 		subscribers[event].push(callback);

// 		// Return unsubscribe function
// 		return () =>
// 		{
// 			subscribers[event] = subscribers[event].filter(cb => cb !== callback);
// 		};
// 	};

// 	const publish = (event, data) =>
// 	{
// 		if (!subscribers[event]) return;
// 		subscribers[event].forEach(callback => callback(data));
// 	};

// 	return { subscribe, publish };
// })();










class Overlay {
	constructor() {
		this.overlay = null;
		this.isActive = false;

		// Reference count of outstanding show() calls not yet matched by a hide().
		// callApi2WithOverlay() calls show()/hide() around every request, and pages
		// routinely have more than one request in flight at once (their own loads,
		// plus PrimaryLayout's concurrent auth/system-message/menu calls) — without
		// this counter, two overlapping calls can interleave so that a later show()
		// creates the overlay but an earlier call's hide() (which only ever checked
		// "is *an* overlay currently active", not "is *my* overlay still needed")
		// never runs again for it, leaving it stuck on screen. See CLAUDE.md / the
		// Resource Planning module notes for how this was found.
		this.activeCount = 0;
	}



	show(customMessage = '')
	{
		const message = customMessage ? customMessage : 'Processing...';

		this.activeCount++;

		const overlayHtml = `
			<div class="global-processing-overlay">
				<div class="overlay-text">
					<div class="modal-content">
						<div class="modal-body p-4 px-5">
						<h3 id="global-processing-overlay-message" class="text-center">${message}</h3>
						<div class="loader-container text-center">
							<img id="global-processing-overlay-loader-image" src="https://assets.lotusai.co/portal/images/logo-radial-2.gif" style="height: 80px; width: auto; display: inline-block;" />
						</div>
					</div>
					</div>
				</div>
			</div>
		`;

		if (this.isActive)
		{
			const messageEl = this.overlay.querySelector('.overlay-message');
			if (messageEl)
			{
				//messageEl.textContent = message;
				messageEl.innerHTML = overlayHtml;
			}
			return;
		}

		this.overlay = document.createElement('div');
		this.overlay.className = 'morning-sun fullscreen-overlay';

		const messageContainer = document.createElement('div');
		messageContainer.className = 'overlay-message';
		//messageContainer.textContent = message;
		messageContainer.innerHTML = overlayHtml;

		this.overlay.appendChild(messageContainer);
		document.body.appendChild(this.overlay);
		this.isActive = true;
	}



	hide() {
		// Only the hide() that brings the outstanding count back to zero actually
		// tears down the overlay — an earlier caller finishing first must not hide
		// it out from under a still-in-flight later caller (see the constructor note).
		this.activeCount = Math.max(this.activeCount - 1, 0);
		if (this.activeCount > 0) return;

		if (this.overlay && this.isActive)
		{
			this.overlay.remove();
			this.overlay = null;
			this.isActive = false;
		}
	}
}








const sharedUtil = {
	_overlay: null,
	isInitialised: false,

	init() 
	{
		// Already inditialised. Don't set up  again.
		if (this.isInitialised) return;


		//TODO: Why did I do this. Overkill.
		// // Handle when a "toast:show" is added to the event bus.
		// EventBus.subscribe('toast:show', (data) => {
		// 	Toast.createToast(data);
		// });

		this._overlay = new Overlay();

		this.isInitialised = true;
	},





	/**
	 * Example: 
	 * 
	 * type: 'info', 'success', 'warning', 'error'. Default = 'info'
	 * duration: default = 2000
	 * 
			NotificationService.showToast({
				type: 'info',
				title: 'New Update Available',
				description: 'Version 2.0 is now available for download.',
				duration: 5000
			});	
	 */
	showToast(options) {
		//EventBus.publish('toast:show', options);	//TODO: Why did I do this. Overkill.
		Toast.createToast(options);	//NOTE: We can just call this directly.
	},





	showOverlay(customMessage = '') 
	{
		this.init();

		const message = customMessage ? customMessage : 'Processing...';

		this._overlay.show(message);
	},


	hideOverlay() 
	{
		this.init();
		
		this._overlay.hide();
	},
};

export default sharedUtil;